import styled from "styled-components";
import { NavLink } from "react-router-dom";

export const SidebarMenuContainer = styled.div`
  height: 100vh;
  position: sticky;
  width: 250px;
  direction: rtl;
  background-color: #ffffff;
  box-shadow: -3px 10px 10px 3px #c7c3c3;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-left: 10px;
  @media (max-width: 1024px) {
    width: calc(360px - 48px);
    margin: 0 auto;
    box-shadow: none;
    border-radius: 30px;
    padding-left: 0;
    background-color: #ffffff;
    margin-bottom: 10px;
    height: 80px;
    display: none;
  }
`;
export const LogoContainerr = styled.div`
  height: 72px;
  display: flex;
  align-items: center;
  direction: ltr;
  h2 {
    font-size: 32px;
    font-weight: 700;
    color: ${(props) => props.color};
    margin-right: 10px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const LogoContainer = styled.div`
  width: 100%;
  text-align: center;
  margin: 40px 0 104px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const LogoTitle = styled.p`
  color: #89beff;
  font-weight: 700;
  font-size: 32px;
  margin-right: 10px;
`;

export const NavbarContainer = styled.div`
  width: 100%;
  text-align: center;
  ul a.active {
    background-color: #d1e6ff;
    border-top-left-radius: 24px;
    border-bottom-left-radius: 24px;
  }

  @media (max-width: 1024px) {
    ul {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      height: 80px;
      & :nth-child(4) {
        background-color: azure;
        display: none;
      }
    }
    ul a:nth-of-type(3) {
      order: 1;
    }
    ul a:nth-of-type(1) {
      order: 1;
    }
    ul a.active {
      background-color: transparent;
      border-top-left-radius: none;
      border-bottom-left-radius: none;
    }
  }
  /* @media (max-width: 360px) {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    nav {
      width: 100%;
      position: relative;
    }
    nav ul {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    nav ul li div {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    nav ul li a {
      display: inline-block;
      height: 100%;
    }

    nav ul li:nth-of-type(1) {
      order: 2;
    }

    nav ul li:nth-child(1) .img-wrapper:nth-child(1) {
      background-color: blue;
      width: 54px;
      height: 54px;
      position: relative;
      top: -20px;
      border-radius: 50%;
    }
    nav ul li .img-wrapper img {
      display: block;
    }
    nav ul li.active a {
      background-color: transparent;
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
    nav ul li:nth-of-type(1) :nth-child(1) img{
     position: absolute;
      background-color: green;
      bottom: 70%;
      left: 50%;
      transform: translate(-50%,0);
      padding: 10px;
      border-radius: 50%;
      background: blue;
    }

    nav ul li:nth-of-type(2) {
      order: 1;
    }
    nav ul li:nth-of-type(3) {
      order: 3;
    }
    nav ul li:last-child {
      display: none;
    }
  }  */
`;

export const StyledNavLink = styled(NavLink)`
  display: inline-block;
  padding: 12px 0;
  cursor: pointer;
  color: ${(props) => props.color || "#27548c"};
  width: 100%;
  font-size: 14px;
  font-weight: 500;
  @media (max-width: 360px) {
    padding: 0;
    margin-bottom: 0;
    width: 32%;
  }

  /* /* &:active {
    color: #27548c;
  }

  &:visited {
    color: #27548c;
    background-color: #d1e6ff;
  } */
  /* @media (max-width: 360px) {
    border-radius: 0;
    margin-bottom: 0;
    padding: 0;
  }   */
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.color || "#27548c"};
  @media (max-width: 1024px) {
    flex-direction: column;
    align-items: center;
    padding-right: 0;
    gap: 0;
    justify-content: space-between;
    position: relative;
    p {
      font-size: 14px;
      font-weight: 500;
    }
  }
`;

export const IconDesktopContainer = styled.div`
  display: flex;
  margin: 0 16px 0 24px;
  @media (max-width: 1320px) {
    margin-left: 16px;
  }
  @media (max-width: 1226px) {
    margin-left: 10px;
  }
  @media (max-width: 1196px) {
    margin-left: 5px;
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const IconMobileContainer = styled.div`
  display: none;
  @media (max-width: 1024px) {
    display: block;
  }
`;
